import { Button, Flex } from '#atoms';
import { PATH } from '#const/path';
import useCareersQuery from '#hooks/queries/onboard/useCareersQuery';
import useDegreesQuery from '#hooks/queries/onboard/useDegreesQuery';
import useDeleteCareerMutation from '#hooks/queries/onboard/useDeleteCareerMutation';
import useDeleteDegreeMutation from '#hooks/queries/onboard/useDeleteDegreeMutation';
import usePatchCurrentStepMutation from '#hooks/queries/onboard/usePatchCurrentStepMutation';
import { FloatButtonContainer } from '#molecules';
import { useToast } from '#providers/ToastProvider';
import TagManager from 'react-gtm-module';
import { useNavigate } from 'react-router';
import { useOnBoardStep } from '../../OnBoardStep.hooks';
import HistoryItem from '../HistoryItem';
import HistoryTitle from '../HistoryTitle';
import * as S from '../Step3/styles';

export default function Step5() {
  const navigate = useNavigate();
  const { setStep, isWritten } = useOnBoardStep();
  const { data: degrees } = useDegreesQuery();
  const { data: careers } = useCareersQuery();
  const { mutateAsync: deleteDegree } = useDeleteDegreeMutation();
  const { mutateAsync: deleteCareer } = useDeleteCareerMutation();
  const { showToast } = useToast();
  const { mutateAsync: patchCurrentStep } = usePatchCurrentStepMutation();

  const handleDeleteDegree = async (degreeId: string) => {
    try {
      await deleteDegree(degreeId);
      showToast({
        type: 'success',
        message: '학력이 삭제되었습니다.'
      });
    } catch (err: any) {
      showToast({
        type: 'fail',
        message: '학력 삭제에 실패했습니다.'
      });
    }
  };

  const handleDeleteCareer = async (careerId: string) => {
    try {
      await deleteCareer(careerId);
      showToast({
        type: 'success',
        message: '경력이 삭제되었습니다.'
      });
    } catch (err: any) {
      showToast({
        type: 'fail',
        message: '경력 삭제에 실패했습니다.'
      });
    }
  };

  const handleNext = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'onboarding_career_next_click',
        category: '신규가입 온보딩',
        action: 'onboarding_career_next_click',
        degree: degrees && degrees.length >= 1 ? 1 : 0,
        career: careers && careers.length >= 1 ? 1 : 0,
        value: 2
      }
    });
    patchCurrentStep(6);
    setStep(6);
  };

  return (
    <>
      <S.Wrapper>
        <S.Title>학력 및 경력 정보를{'\n'}입력해 주세요</S.Title>
        <Flex direction="column" gap={56}>
          <Flex direction="column">
            <HistoryTitle
              title="학력"
              onIconClick={() => navigate(PATH.ONBOARD_DEGREE)}
            />
            <div style={{ height: '12px' }} />
            {degrees && degrees.length > 0 ? (
              degrees?.map(degree => (
                <HistoryItem
                  key={degree.id}
                  title={degree.name}
                  startDate={new Date(degree.from)}
                  endDate={degree.at ? new Date(degree.at) : undefined}
                  onDelete={async () => await handleDeleteDegree(degree.id)}
                  onEdit={() => navigate(`${PATH.ONBOARD_DEGREE}/${degree.id}`)}
                />
              ))
            ) : (
              <S.Empty>학교와 학위, 전공 등을 입력하세요.</S.Empty>
            )}
          </Flex>
          <Flex direction="column">
            <HistoryTitle
              title="경력"
              onIconClick={() => navigate(PATH.ONBOARD_CAREER)}
            />
            <div style={{ height: '12px' }} />
            {careers && careers.length > 0 ? (
              careers?.map(career => (
                <HistoryItem
                  key={career.id}
                  title={career.name}
                  startDate={new Date(career.startAt)}
                  endDate={career.endAt ? new Date(career.endAt) : undefined}
                  onDelete={async () => await handleDeleteCareer(career.id)}
                  onEdit={() => navigate(`${PATH.ONBOARD_CAREER}/${career.id}`)}
                />
              ))
            ) : (
              <S.Empty>경력 사항들을 입력하세요.</S.Empty>
            )}
          </Flex>
        </Flex>
      </S.Wrapper>
      <FloatButtonContainer>
        <Button onClick={handleNext}>
          {isWritten(degrees as [], careers as [])}
        </Button>
      </FloatButtonContainer>
    </>
  );
}
